import { useParams, Navigate } from "@/lib/router-compat";
import { InlineEligibilityForm } from "@/components/InlineEligibilityForm";
import LearnPageLayout from "@/components/LearnPageLayout";
import { page1 } from "./learnDataP1";
import { page2 } from "./learnDataP2";
import { page3 } from "./learnDataP3";
import { page4 } from "./learnDataP4";
import { page5 } from "./learnDataP5";
import { page6 } from "./learnDataP6";
import { page7 } from "./learnDataP7";
import { page8 } from "./learnDataP8";
import { page9 } from "./learnDataP9";
import { page10 } from "./learnDataP10";
import { whereCanIGetSaint } from "./learnDataWhereCanIGetSaint";
import { saintNearMe } from "./learnDataSaintNearMe";
import { saintCost } from "./learnDataSaintCost";
import { doesInsuranceCoverSaint } from "./learnDataDoesInsuranceCoverSaint";
import { saintMiami } from "./learnDataSaintMiami";
import { saintFortLauderdale } from "./learnDataSaintFortLauderdale";
import { pageSaintBocaRaton } from "./learnDataSaintBocaRaton";
import { pageSaintEastCoast } from "./learnDataSaintEastCoast";
import { pageHowFastSaint } from "./learnDataHowFastSaint";
import { pageWhatToExpect } from "./learnDataWhatToExpect";
import { page5DayTms } from "./learnData5DayTms";
import { pageFastTrd } from "./learnDataFastTrd";
import { pageAntidepressantsDontWork } from "./learnDataAntidepressantsDontWork";
import { pageBeyondMedication } from "./learnDataBeyondMedication";
import { pageFmriGuided } from "./learnDataFmriGuided";
import { pageSaintVsTraditional } from "./learnDataSaintVsTraditional";
import { pageSaintVsSpravato } from "./learnDataSaintVsSpravato";
import { pageSaintVsKetamine } from "./learnDataSaintVsKetamine";
import { pageBcbsSaint } from "./learnDataBcbsSaint";
import { saintFlorida } from "./learnDataSaintFlorida";
import { pageWhatIsVerifiedProvider } from "./learnDataWhatIsVerifiedProvider";
import { pageHowToFindSaintProvider } from "./learnDataHowToFindSaintProvider";
import { pageQuestionsToAskProvider } from "./learnDataQuestionsToAskProvider";
import { pageOutpatientSaint } from "./learnDataOutpatientSaint";
import { pageWhyAntidepressantNotWorking } from "./learnDataWhyAntidepressantNotWorking";
import { pageCanTmsHelpAfterAntidepressants } from "./learnDataCanTmsHelpAfterAntidepressants";
import { pageCanSaintHelpAfterMeds } from "./learnDataCanSaintHelpAfterMeds";
import { pageWhatComesAfterMedTherapy } from "./learnDataWhatComesAfterMedTherapy";
import { pageHowManyAntidepressants } from "./learnDataHowManyAntidepressants";
import { pageTwoAntidepressantsDontWork } from "./learnDataTwoAntidepressantsDontWork";
import { pageNothingWorks } from "./learnDataNothingWorks";
import { pageNoMoreMedication } from "./learnDataNoMoreMedication";
import { pageFastestTreatment } from "./learnDataFastestTreatment";
import { pageIsSaintAvailableNearMe } from "./learnDataIsSaintAvailableNearMe";
import { pageSaintBrainTarget } from "./learnDataSaintBrainTarget";
import { pageSaintBetweenSessions } from "./learnDataSaintBrainTarget";
import { pageSaintStartQuickly } from "./learnDataSaintBrainTarget";
import { pageSaintTravelCompanion } from "./learnDataSaintTravelCompanion";
// pageTiredOfFeelingDepressed moved to learnDataTiredOfFeelingDepressed.tsx
import { pageNothingWorksForDepression } from "./learnDataEmotionalSearches";
import { pageLostHope } from "./learnDataEmotionalSearches";
import { pageDepressionKeepsComingBack } from "./learnDataEmotionalSearches";
import { pageDepressedForYears } from "./learnDataEmotionalSearches";
// pageDepressionWontGoAway moved to learnDataDepressionWontGoAway.tsx
import { pageDontWantToChangeAntidepressants } from "./learnDataEmotionalSearches";
import { pageOptionsIfTherapyDoesntHelp } from "./learnDataEmotionalSearches";
import { pageDepressionImpossibleToTreat } from "./learnDataEmotionalSearches";
import { pageTravelForSaint } from "./learnDataTravelForSaint";
import { pageSaintVsEct } from "./learnDataComparisons";
import { pageSaintVsAntidepressants } from "./learnDataComparisons";
import { pageTmsVsMedication as pageTmsVsMedicationForDepression } from "./learnDataComparisons";
import { pageAcceleratedVsConventional } from "./learnDataComparisons";
import { pageSaintVsAccelerated } from "./learnDataComparisons";
// SAINT protocol questions
import { pageHowDoesSaintWork } from "./learnDataHowDoesSaintWork";
import { pageSaintHowLongTake } from "./learnDataSaintHowLongTake";
import { pageSaintSessions } from "./learnDataSaintSessions";
import { pageSaintMri } from "./learnDataSaintMri";
import { pageSaintAnesthesia } from "./learnDataSaintAnesthesia";
import { pageSaintAnesthesiaMedication } from "./learnDataSaintAnesthesiaMedication";
import { pageSaintSideEffects } from "./learnDataSaintSideEffects";
import { pageSaintFeelLike } from "./learnDataSaintFeelLike";
import { pageSaintDriveWork } from "./learnDataSaintDriveWork";
import { pageSaintWorkDuringTreatment } from "./learnDataSaintWorkDuringTreatment";
import { pageSaintOutpatientHospital } from "./learnDataSaintOutpatientHospital";
import { pageSaintEligibility } from "./learnDataSaintEligibility";
import { pageSaintAfterTreatment } from "./learnDataSaintAfterTreatment";
import { pageSaintForTrd } from "./learnDataSaintForTrd";
import { pageSaintAfterMedicationFailure } from "./learnDataSaintAfterMedicationFailure";
import { pageSaintHowFastVsTms } from "./learnDataSaintHowFastVsTms";
import { pageSaintQuestions } from "./learnDataSaintQuestions";
import { pageSaintCostHub } from "./learnDataSaintCostHub";
// Treatment failure / TRD
import { pageSignsOfTrd } from "./learnDataSignsOfTrd";
import { pageNewTreatmentsForTrd } from "./learnDataNewTreatmentsForTrd";
import { pageTmsAfterAntidepressantsFail } from "./learnDataTmsAfterAntidepressantsFail";
import { pageCanDepressionResistMedication } from "./learnDataCanDepressionResistMedication";
// Emotional / patient-language (standalone — different slugs from learnDataEmotionalSearches)
import { pageDepressionWontGoAway as pageDepressionWontGoAwayEvenWithMed } from "./learnDataDepressionWontGoAway";
import { pageDepressionComingBack as pageWhyDoesMyDepressionKeepComingBack } from "./learnDataDepressionComingBack";
import { pageStillDepressedOnMedication } from "./learnDataStillDepressedOnMedication";
import { pageTiredOfFeelingDepressed as pageTiredOfFeelingDepressedOptionsLeft } from "./learnDataTiredOfFeelingDepressed";
import { pageTherapyNotHelping } from "./learnDataTherapyNotHelping";
// Alternatives / advanced
import { pageAdvancedDepressionTreatment } from "./learnDataAdvancedDepressionTreatment";
import { pageAlternativeToAntidepressants } from "./learnDataAlternativeToAntidepressants";
import { pageAlternativeToEct } from "./learnDataAlternativeToEct";
import { pageFastDepressionTreatment } from "./learnDataFastDepressionTreatment";
import { pageTmsVsMedication } from "./learnDataTmsVsMedication";
import { pageSaintTreatmentWeekDayByDay } from "./learnDataSaintDayByDay";
import { pageTmsVsSpravato } from "./learnDataTmsVsSpravato";
import {
  pageHowToFindLegitimateSaintProvider,
  pageWhatToLookForInDepressionCenter,
} from "./learnDataProviderQuestions";
import { pageWhereCanIGetSaintTreatment } from "./learnDataWhereCanIGetSaintTreatment";
import { pageSaintTmsLocations } from "./learnDataSaintTmsLocations";
import { pageSaintVsOneDayTms } from "./learnDataSaintVsOneDayTms";
import { pageSaintVsDeepTms } from "./learnDataSaintVsDeepTms";
import { pageSaintVsMert } from "./learnDataSaintVsMert";
import { pageSaintVsPsilocybin } from "./learnDataSaintVsPsilocybin";
import { pageSaintVsVns } from "./learnDataSaintVsVns";
import { pageIsSaintCoveredByInsurance } from "./learnDataIsSaintCoveredByInsurance";
import { pageWhatIsSaintTreatmentForDepression } from "./learnDataWhatIsSaintTreatmentForDepression";
import { pageSaintTmsProtocol } from "./learnDataSaintTmsProtocol";
import { pageStanfordAcceleratedIntelligentNeuromodulationTherapy } from "./learnDataStanfordAcceleratedIntelligentNeuromodulationTherapy";
import { pageCanDepressionCausePhysicalPain } from "./pageCanDepressionCausePhysicalPain";
import { pageAlwaysTiredDepressionFatigue } from "./pageAlwaysTiredDepressionFatigue";
import { pageAnxietyChestTightness } from "./pageAnxietyChestTightness";
import { pageCantStopCrying } from "./pageCantStopCrying";
import { pageAnxietyWorseInMorning } from "./pageAnxietyWorseInMorning";
import { pageCanSaintMakeDepressionWorse } from "./learnDataCanSaintMakeDepressionWorse";
import { pageWhatIfSaintDoesntWork } from "./learnDataWhatIfSaintDoesntWork";
import { pageSaintTmsSuccessRates } from "./learnDataSaintTmsSuccessRates";
import { pageSaintTmsResults } from "./learnDataSaintTmsResults";
import { pageCognitiveFxVsSaint } from "./learnDataCognitiveFxVsSaint";
import { pageIsSaintTmsSafe } from "./learnDataIsSaintTmsSafe";
import { pageAmpaTmsCost } from "./learnDataAmpaTmsCost";
import { pageAmpaOneVsNeurostarVsBrainsway } from "./learnDataAmpaOneVsNeurostarVsBrainsway";
import { pageSaintVsAmpaOne } from "./learnDataSaintVsAmpaOne";
import { pageAmpaTmsReviewsWhatToExpect } from "./learnDataAmpaTmsReviewsWhatToExpect";
import { pageAmpaTmsFlorida } from "./learnDataAmpaTmsFlorida";
import { pageCameraGuidedPortableTms } from "./learnDataCameraGuidedPortableTms";
import { pageAmpaReceptorsKetamineAndTms } from "./learnDataAmpaReceptorsKetamineAndTms";
import { pageSaintDisclaimer } from "./learnDataSaintDisclaimer";
import { pageBeamF3VsFmri } from "./learnDataBeamF3VsFmri";
import { pageSaintProsAndCons } from "./learnDataSaintProsAndCons";
import { pageLocalVsTravelFiveDay } from "./learnDataLocalVsTravelFiveDay";
import { pageSaintTmsUtah } from "./learnDataSaintTmsUtah";
import { pageSaintTmsNevada } from "./learnDataSaintTmsNevada";
import { pageSaintTmsColorado } from "./learnDataSaintTmsColorado";
import { pageSaintAgeRequirements } from "./learnDataSaintAgeRequirements";
import { pageReferPatient } from "./learnDataReferPatient";
import { pageSaintVsTdcs } from "./learnDataSaintVsTdcs";
import { pageSaintVsNeurofeedback } from "./learnDataSaintVsNeurofeedback";
import type { LearnPageData } from "./learnShared";

const allPages: LearnPageData[] = [
  page1,
  page2,
  page3,
  page4,
  page5,
  page6,
  page7,
  page8,
  page9,
  page10,
  whereCanIGetSaint,
  saintNearMe,
  saintCost,
  doesInsuranceCoverSaint,
  pageSaintEastCoast,
  pageHowFastSaint,
  pageWhatToExpect,
  page5DayTms,
  pageFastTrd,
  pageAntidepressantsDontWork,
  pageBeyondMedication,
  pageFmriGuided,
  pageSaintVsTraditional,
  pageSaintVsSpravato,
  pageSaintVsKetamine,
  pageWhatIsVerifiedProvider,
  pageHowToFindSaintProvider,
  pageQuestionsToAskProvider,
  pageOutpatientSaint,
  pageWhyAntidepressantNotWorking,
  pageCanTmsHelpAfterAntidepressants,
  pageCanSaintHelpAfterMeds,
  pageWhatComesAfterMedTherapy,
  pageHowManyAntidepressants,
  pageTwoAntidepressantsDontWork,
  pageNothingWorks,
  pageNoMoreMedication,
  pageFastestTreatment,
  pageIsSaintAvailableNearMe,
  pageSaintBrainTarget,
  pageSaintBetweenSessions,
  pageSaintStartQuickly,
  pageSaintTravelCompanion,
  pageNothingWorksForDepression,
  pageLostHope,
  pageDepressionKeepsComingBack,
  pageDepressedForYears,
  pageDontWantToChangeAntidepressants,
  pageOptionsIfTherapyDoesntHelp,
  pageDepressionImpossibleToTreat,
  pageTravelForSaint,
  pageSaintVsEct,
  pageSaintVsAntidepressants,
  pageTmsVsMedicationForDepression,
  pageAcceleratedVsConventional,
  pageSaintVsAccelerated,
  // SAINT protocol questions
  pageHowDoesSaintWork,
  pageSaintHowLongTake,
  pageSaintSessions,
  pageSaintMri,
  pageSaintAnesthesia,
  pageSaintAnesthesiaMedication,
  pageSaintSideEffects,
  pageSaintFeelLike,
  pageSaintDriveWork,
  pageSaintWorkDuringTreatment,
  pageSaintOutpatientHospital,
  pageSaintEligibility,
  pageSaintAfterTreatment,
  pageSaintForTrd,
  pageSaintAfterMedicationFailure,
  pageSaintHowFastVsTms,
  pageSaintQuestions,
  pageSaintCostHub,
  // Treatment failure / TRD
  pageSignsOfTrd,
  pageNewTreatmentsForTrd,
  pageTmsAfterAntidepressantsFail,
  pageCanDepressionResistMedication,
  // Emotional / patient-language (standalone)
  pageDepressionWontGoAwayEvenWithMed,
  pageWhyDoesMyDepressionKeepComingBack,
  pageStillDepressedOnMedication,
  pageTiredOfFeelingDepressedOptionsLeft,
  pageTherapyNotHelping,
  // Alternatives / advanced
  pageAdvancedDepressionTreatment,
  pageAlternativeToAntidepressants,
  pageAlternativeToEct,
  pageFastDepressionTreatment,
  pageTmsVsMedication,
  pageSaintTreatmentWeekDayByDay,
  pageTmsVsSpravato,
  pageHowToFindLegitimateSaintProvider,
  pageWhatToLookForInDepressionCenter,
  pageWhereCanIGetSaintTreatment,
  pageSaintTmsLocations,
  pageSaintVsOneDayTms,
  pageSaintVsDeepTms,
  pageSaintVsMert,
  pageSaintVsPsilocybin,
  pageSaintVsVns,
  pageIsSaintCoveredByInsurance,
  pageWhatIsSaintTreatmentForDepression,
  pageSaintTmsProtocol,
  pageStanfordAcceleratedIntelligentNeuromodulationTherapy,
  pageCanDepressionCausePhysicalPain,
  pageAlwaysTiredDepressionFatigue,
  pageAnxietyChestTightness,
  pageCantStopCrying,
  pageAnxietyWorseInMorning,
  pageCanSaintMakeDepressionWorse,
  pageWhatIfSaintDoesntWork,
  pageSaintTmsSuccessRates,
  pageSaintTmsResults,
  pageCognitiveFxVsSaint,
  pageIsSaintTmsSafe,
  pageAmpaTmsCost,
  pageAmpaOneVsNeurostarVsBrainsway,
  pageSaintVsAmpaOne,
  pageAmpaTmsReviewsWhatToExpect,
  pageAmpaTmsFlorida,
  pageCameraGuidedPortableTms,
  pageAmpaReceptorsKetamineAndTms,
  pageSaintDisclaimer,
  pageBeamF3VsFmri,
  pageSaintProsAndCons,
  pageLocalVsTravelFiveDay,
  pageSaintTmsUtah,
  pageSaintTmsNevada,
  pageSaintTmsColorado,
  pageSaintAgeRequirements,
  pageReferPatient,
  pageSaintVsTdcs,
  pageSaintVsNeurofeedback,
];

/**
 * Renders a single patient-education article at /learn/:slug.
 * Uses the shared LearnPageLayout (Navbar, Footer, schema, CTA, crisis notice).
 */
const LearnArticleRoute = () => {
  const { slug } = useParams<{ slug: string }>();
  const page = allPages.find((p) => p.slug === slug);

  if (!page) {
    return <Navigate to="/learn" replace />;
  }

  // For the "still depressed on medication" article, embed the real SAINT
  // eligibility form (same form + tracking as /saint) below the intro and
  // again at the end — rendered as an actual <form>, not a link.
  let sections = page.sections;
  if (slug === "why-still-depressed-while-taking-medication") {
    const formSection = {
      heading: "",
      body: (
        <InlineEligibilityForm source="learn-still-depressed-eligibility" />
      ),
    };
    sections = [
      ...page.sections.slice(0, 1),
      formSection,
      ...page.sections.slice(1),
      formSection,
    ] as typeof page.sections;
  }

  return (
    <LearnPageLayout
      title={page.title}
      description={page.description}
      canonical={page.canonical}
      h1={page.h1}
      breadcrumbLabel={page.breadcrumbLabel}
      crumbs={page.crumbs}
      shortAnswer={page.shortAnswer}
      keyTakeaways={page.keyTakeaways}
      sections={sections}
      faqs={page.faqs}
      sources={page.sources}
      schemaJson={page.schemaJson}
      relatedLinks={page.relatedLinks}
      reviewBlock={page.reviewBlock}
      safetyBlock={page.safetyBlock}
      trademarkFooter={page.trademarkFooter}
      ctaBand={page.ctaBand}
      toc={page.toc}
    />
  );
};

export function findLearnPageBySlug(slug: string) {
  return allPages.find((p) => p.slug === slug);
}

export default LearnArticleRoute;
